declare global {
    interface Window {
        dataLayer: any[];
    }
}

window.dataLayer = window.dataLayer || [];

const sendGa = (event: string, ecommerce: any) => {
    window.dataLayer.push({ event, ecommerce });
};

export default sendGa;
